import { json } from '@remix-run/node';
import NotFoundPage from '@modules/error/page/NotFoundPage';
import React from 'react';
import { useCurrentCategory } from '@rocco/ui/website-header/hooks/use-current-category';

export const loader = async () => {
    return json(
        {
            pageTheme: 'transparent',
        },
        {
            status: 404,
            statusText: 'Not found',
        }
    );
};

const NotFoundPageWithCategory = () => {
    const { setCategory } = useCurrentCategory();

    // Set the current category for header navigation
    React.useEffect(() => {
        setCategory(null);
    }, [setCategory]);

    return <NotFoundPage />;
};

export default NotFoundPageWithCategory;
